import { PropsWithChildren } from "react";
import classNames from "classnames";
import "./styles.scss";
import { Box, SxProps } from "@mui/material";

export const LandingPageSection = ({
  className,
  children,
  id,
  sx,
}: PropsWithChildren<{ className?: string; id?: string; sx?: SxProps }>) => {
  return (
    <Box
      component="section"
      className={classNames("landing-page-section", className)}
      id={id}
      sx={sx}
    >
      <div className="site-wrapper">{children}</div>
    </Box>
  );
};
